import { useRef } from "react";

import Navigation from "./Navigation";
import ScrollToTop from "./ScrollToTop";

import Lightbox from "@/components/Lightbox";

type LayoutProps = {
  children: React.ReactNode;
};
const Layout = ({ children }: LayoutProps) => {
  const scrollElementRef = useRef<HTMLElement>(null);

  return (
    <div className="flex h-screen overflow-hidden">
      <Navigation />
      <div className="flex h-full flex-1 flex-col overflow-hidden bg-white">
        <main ref={scrollElementRef} className="flex h-full overflow-auto">
          <ScrollToTop scrollElementRef={scrollElementRef} />
          <div className="size-full">{children}</div>
        </main>
      </div>
      <Lightbox />
    </div>
  );
};

export default Layout;
